module.exports = __webpack_public_path__ + "static/media/Download.76549f20.svg";